module.exports = __webpack_public_path__ + "img/0029.84000749.gif";